import React from 'react';
import { Route, Redirect, useRouteMatch, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { common } from '../gql/common';
import { papCategories } from '../constants/postad';

const isLoggedIn = user => {
  const { user: userObj, userid } = user || {};
  return !!(userid || (userObj && userObj.id));
};

// eslint-disable-next-line
const isQuikr = __ANALYTICS_DOMAIN_CLIENT__ === 'Quikr';

const PrivateRoute = ({ component: Component, redirectTo, ...rest }) => {
  const { loading, data } = useQuery(common);
  const routeParams = useRouteMatch(
    `/post-ad/:category(${papCategories})/:subcat([a-zA-Z0-9-]+)?/confirm`
  );
  const { params: { category, subcat } = {} } = routeParams || {};
  const location = useLocation();

  if (loading) {
    return null;
  }

  const geturl = () => {
    let url = '';
    switch (redirectTo) {
      case 'pap':
        url = isQuikr ? `/post-ad/${category}${subcat ? `/${subcat}` : ''}` : '/postad';
        break;
      default:
        url = isQuikr
          ? `/SignIn?redirect=${location.pathname}`
          : `/nm/authorize/signin?redirect_url=${location.pathname}`;
        break;
    }
    return url;
  };

  return (
    <Route
      {...rest}
      render={() => {
        if (process.env.BUILD_TARGET === 'server') {
          const { user } = data;
          const url = geturl();
          return isLoggedIn(user) ? <Component user={user.user} /> : <Redirect to={url} />;
        } else {
          return <Component />;
        }
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.object,
  redirectTo: PropTypes.string
};

export default PrivateRoute;
